import { Card } from "react-bootstrap";
import Web from "./Web";
export default function Dasboard() {
    return <Card>
        <Card.Body>
            <Web />
        </Card.Body>
    </Card>
}